import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Logo } from '@/components/Logo';
import { logger } from '@/lib/logger';

export default function Invite() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    const handleInvite = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const refCode = searchParams.get('ref');
        
        if (!refCode) {
          throw new Error('No referral code provided');
        }
        
        // Call the database function to update referral status
        // const { data, error: funcError } = await supabase.rpc(
        //   'update_referral_status_by_code' as any,
        //   { ref_code: refCode }
        // );
        
        // if (funcError) {
        //   logger.error('Error updating referral status:', funcError);
        //   throw funcError;
        // }
        
        // Store the referral code in localStorage for persistence
        localStorage.setItem('referralCode', refCode);
        
        // Redirect to landing page with the referral code
        navigate(`/?ref=${refCode}`);
      } catch (err) {
        logger.error('Error processing invite:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
        
        // Redirect to landing page after a short delay even if there was an error
        setTimeout(() => {
          navigate('/');
        }, 3000);
      } finally {
        setLoading(false);
      }
    };
    
    handleInvite();
  }, [location, navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1A1F2C] to-[#7E69AB]">
      <div className="absolute inset-0 bg-[url('/background.webp')] bg-cover bg-center opacity-10"></div>
      <div className="max-w-md w-full mx-4 p-8 bg-white/10 backdrop-blur-md rounded-lg shadow-xl relative z-10 text-center">
        <Logo size="lg" className="text-white mb-4 mx-auto" />
        
        {loading ? (
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Processing invitation...</h2>
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
            </div>
          </div>
        ) : error ? (
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Something went wrong</h2>
            <p className="text-gray-300 mb-4">{error}</p>
            <p className="text-gray-300">Redirecting to home page...</p>
          </div>
        ) : (
          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Processing invitation...</h2>
            <div className="flex justify-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}